import api from '../..'

type Id = string | number

export type ResetManyRansack = {
  user_id_in?: number[]
  user_id_not_in?: number[]
  g?: any[]
}

export type ResetManyOptions = {
  search?: string
  q: ResetManyRansack
}

const resetMany = (course: Id, { search, q }: ResetManyOptions) => {
  return api.put(`administration/multiple_applications`, {
    data: {
      search,
      q,
      courseId: course,
    },
  })
}

export default resetMany
